module.exports = __webpack_public_path__ + "img/wallet.ad4b1f5c.svg";